<div class="form-item">
    <label [attr.for]="id" [innerText]="label"></label>
    <div *ngIf="message" class="field-message" [id]="id + '-message'">
        <div [innerHTML]="message"></div>
        <div class="accolade "></div>
    </div>
    <div class="form-columns">
        <div class="form-item-column">
            <div class="file" [attr.data-file]="(file$ | async) || ('no_file' | translate)">
                <input type="file" ng2FileSelect [uploader]="uploader"
                       [attr.aria-invalid]="error$ | async"
                       [id]="id"
                       [ngClass]="{'error': error$ | async}"
                       [attr.aria-describedby]="describedBy$ | async"
                       #fileUpload />
                <span class="file__button" translate="select_file" [id]="id + '-file'"></span>
            </div>
            <span class="help-text" *ngIf="limitations" [innerText]="limitations"></span>
        </div>
        <div class="form-item-column">
            <div *ngIf="error$ | async as error" class="field-message error" role="alert" [id]="id + '-error'">
                <div [innerHTML]="error | translate"></div>
                <div class="accolade"></div>
            </div>
        </div>
    </div>
    <div *ngIf="uploader.isUploading" class="spinner" role="alert">
        <div>&hellip; {{ 'uploading' | translate}}</div>
    </div>
</div>
